import { SecondaryButton } from '@joor/design-system'

import { formatNameWithCode } from 'utils/formatters'

import { OrderData } from '../../../Overview/Overview'
import { ReviewPageIds } from 'features/Orders/Review/review.ids'

interface RetailerInfoProps {
  order?: OrderData
  openAssignRetailerModal?: () => void
}

export default function RetailerInfo({
  order,
  openAssignRetailerModal,
}: RetailerInfoProps) {
  if (order?.orphanRetailer) {
    return (
      <>
        {order?.orphanRetailer?.retailerName}
        <br />
        <SecondaryButton
          onClick={openAssignRetailerModal}
          data-testid={'assign-to-retailer'}
          id={ReviewPageIds.AssignRetailerButtonId}
        >
          Assign
        </SecondaryButton>
      </>
    )
  }

  if (order?.isOrphan) {
    return (
      <SecondaryButton
        onClick={openAssignRetailerModal}
        data-testid={'assign-to-retailer'}
        id={ReviewPageIds.AssignRetailerButtonId}
      >
        Assign
      </SecondaryButton>
    )
  }
  if (!order?.retailerProfile?.code) {
    return (
      <>
        {formatNameWithCode(
          order?.retailerProfile?.displayName,
          order?.retailerProfile?.code,
        )}
      </>
    )
  }

  return <>{order?.retailerProfile?.displayName}</>
}
